import {
  inject, onBeforeUnmount, watch, type InjectionKey, type Ref,
} from 'vue';

interface Page {
  busy?: boolean;
}

export const pageKey = Symbol('jk/page') as InjectionKey<Page>;

export const usePage = () => inject(pageKey);

export const syncPageBusy = (value: Ref<boolean>) => {
  const page = usePage();

  watch(value, (newValue) => {
    if (page) {
      page.busy = newValue;
    }
  }, { immediate: true });

  onBeforeUnmount(() => {
    if (page) {
      page.busy = false;
    }
  });
};
